export const adaptFiguraProfesional = (figuraProfesionalData) => {
    return {
        id: figuraProfesionalData?.idFiguraProfesional,
        displayName: figuraProfesionalData?.descripcion,
        name: figuraProfesionalData?.descripcion
    }
}

export const adaptFiguraProfesionalArray = (
    figuraProfesionales
) => {
    return structuredClone(figuraProfesionales?.allFiguraProfesional)
        ?.map(figuraProfesional => adaptFiguraProfesional(figuraProfesional));
}

export const adaptFiguraProfesionalByIdArray = (
    figuraProfesionales
) => {
    return structuredClone(figuraProfesionales?.allFiguraProfesionalById)
        ?.map(figuraProfesional => adaptFiguraProfesional(figuraProfesional));
}